<template>
  <v-container>
    <h2>
      Preferred loan term?
    </h2>

    <div
      v-for="(item, index) in loanRepaymentTypes"
      :key="index"
      class="option-wrapper">
      <button
        class="default-btn blue"
        @click.prevent="onRepayMethodClicked(item.name)"
      >{{ item.title }}</button>

      <v-tooltip v-if="item.description" right>
        <template v-slot:activator="{ on }">
          <v-icon color="#ffca83" v-on="on">mdi-information</v-icon>
        </template>
        {{ item.description }}
      </v-tooltip>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'QuestionnaireRepayLoanStep',
  computed: {
    ...mapState('questionnaireStore', {
      loanRepaymentTypes: ({ questions }) => questions ? questions.loanRepaymentTypes : [],
    }),
  },
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    async onRepayMethodClicked (item) {
      await this.updateMatchData({ loanPaymentTerms: item })
      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep {
  .v-icon {
    position: absolute;
    right: -30px;

    font-size: 32px;
  }
}
</style>
